import { OutlineXCircleErrorIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { ConfirmPopup } from '~/commonComponents';

export interface IWaitBeforeYouGoPopupProps {
  isOpen: boolean;
  onGoBack: () => void;
  onLeave: () => void;
}

/**
 * Shown when the office tries to skip the onsite-interview step right after
 * posting a job (via the "I'll Do It Later" button on the Work Details page).
 * Confirms they understand candidates can't apply until interviews are added.
 */
export const WaitBeforeYouGoPopup = ({
  isOpen,
  onGoBack,
  onLeave,
}: IWaitBeforeYouGoPopupProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    // @ts-expect-error - ConfirmPopup is not typed
    <ConfirmPopup
      Icon={() => <OutlineXCircleErrorIcon size={74} color={colors.primary[500]} />}
      title="Wait, Before You Go"
      titleStyle={{ marginBottom: 20, marginTop: 20 }}
      description="Candidates can't apply to your job posting until onsite interviews are added. Do you still want to leave?"
      descriptionStyle={{ marginBottom: 40 }}
      leftButtonText="Go Back"
      leftButtonAction={onGoBack}
      rightButtonText="Leave"
      rightButtonAction={onLeave}
    />
  );
};
